import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { productListReducers, productDetailReducers } from './reducers/productReducers';
import { cartReducers} from './reducers/cartReducers';
import { userLoginReducer, userRegisterReducer, userDetailsReducer , userUpdateProfileReducer } from './reducers/userReducers';
import { orderCreateReducer, orderDetailsReducer, orderPayReducer, orderListMyReducer } from './reducers/orderReducers';
import { voucherValidateReducer } from './reducers/voucherReducers';
import { passwordResetRequestReducer, passwordResetConfirmReducer } from './reducers/passwordResetReducers';
import { pricingReducer } from './reducers/pricingReducers';
import { 
  bookGenerateReducer, 
  genaiJobDetailsReducer, 
  genaiMyJobsReducer, 
  genaiTemplatesReducer, 
  genaiDeleteJobReducer,
  genaiStoryReducer,
  genaiImagesReducer,
  genaiApproveStoryReducer,
  genaiRegenerateStoryReducer,
  genaiRegenerateCoverReducer,
  genaiApprovePagesReducer,
  genaiRegeneratePageReducer,
  genaiApproveFinalReducer,
  genaiRetryJobReducer,
} from './reducers/genaiReducers';


// TODO: Create your reducers in a reducers folder
// For now, using an empty reducer as placeholder
const rootReducer = combineReducers({
  // Add your reducers here:
  productList: productListReducers,
  productDetails: productDetailReducers,
  cart: cartReducers,
  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userDetails: userDetailsReducer,
  userUpdateProfile: userUpdateProfileReducer,
  orderCreate: orderCreateReducer,
  orderDetails: orderDetailsReducer,
  orderPay: orderPayReducer,
  orderListMy: orderListMyReducer,
  voucherValidate: voucherValidateReducer,
  passwordResetRequest: passwordResetRequestReducer,
  passwordResetConfirm: passwordResetConfirmReducer,
  bookGenerate: bookGenerateReducer,
  genaiJobDetails: genaiJobDetailsReducer,
  genaiMyJobs: genaiMyJobsReducer,
  genaiTemplates: genaiTemplatesReducer,
  genaiDeleteJob: genaiDeleteJobReducer,
  genaiStory: genaiStoryReducer,
  genaiImages: genaiImagesReducer,
  genaiApproveStory: genaiApproveStoryReducer,
  genaiRegenerateStory: genaiRegenerateStoryReducer,

  genaiRegenerateCover: genaiRegenerateCoverReducer,
  genaiApprovePages: genaiApprovePagesReducer,
  genaiRegeneratePage: genaiRegeneratePageReducer,
  genaiApproveFinal: genaiApproveFinalReducer,
  genaiRetryJob: genaiRetryJobReducer,
  pricing: pricingReducer,
});

const store = configureStore({
  reducer: rootReducer,
  // Redux Toolkit includes thunk middleware by default
  // DevTools are also enabled automatically in development
});

export default store;